var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRelations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a-relation",
    fill: "currentColor",
    d: "M14.7 4.85Q13.6 3.7 12.05 3.4q-1.5-.25-3 .3-1.55.7-2.35 1.95-.8 1.2-.8 2.85 0 2.2 1.5 3.7t3.7 1.5q1.65 0 2.85-.85 1.25-.75 1.9-2.3.6-1.55.35-3.05-.35-1.5-1.5-2.65m9.65 13.4q-1.65-.75-3.55-.6-2 .25-3.3 1.35-1.85-1.9-4.7-2.5-2.6-.55-5.25.5-2.5 1.05-4.05 3.35-1.5 2.3-1.5 5.1 0 .5.35.9.4.4.95.4h15.6q.45 0 .85-.4.45-.45.45-.9h6.5q.45 0 .85-.4.45-.45.45-.9-.1-2-1-3.5-1.05-1.5-2.65-2.4m.95-6.6q-.25-1.1-1.05-2-.9-.85-2.05-1.05-1.05-.2-2.25.2-1.15.55-1.75 1.45-.6.95-.6 2.15 0 1.65 1.05 2.8 1.2 1.1 2.85 1.1 1.2 0 2.1-.65.95-.55 1.45-1.75.45-1.2.25-2.25Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a-relation"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRelations);
export default __webpack_public_path__ + "static/media/icon-relations.5b56f35ad13cf90652d14a01153d0b4e.svg";
export { ForwardRef as ReactComponent };